<template>
  <hm-content title="">
    <div class="table-panel flex flex-start">
      <!-- <el-input
        clearable
        v-model.trim="searchCondition.roleName"
        placeholder="请输入角色名称"
        size="small"
        class="ipt mr10"
      ></el-input> -->
      <el-button type="primary" size="small" @click="batchSetting"
        >批量设置角色</el-button
      >
    </div>
    <!-- <div class="flex flex-end">
      <div @click="batchSetting">
        <span class="delete-icon hmicon icon-xitong"></span>
        批量设置
      </div>
    </div> -->
    <div class="table-panel">
      <el-table :data="list" style="width: 100%" stripe border size="small">
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="用户账号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="realname"
          label="用户名称"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workNum"
          label="工号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="departName"
          label="所属机构"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="isManager"
          label="是否主管"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.isManager === "yes" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="workingState"
          label="状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.workingState === 'yes'">在职</span>
            <span v-if="scope.row.workingState === 'no'">离职</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="syncFlag"
          label="同步状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.syncFlag === "erp" ? "同步" : "非同步" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="memberMobile"
          label="绑定会员信息"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.memberMobile">
              <div>手机号：{{ scope.row.memberMobile }}</div>
              <div>会员名：{{ scope.row.memberName }}</div>
            </div>
            <div v-else>未绑定</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          layout="total,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="批量设置角色"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div>
        <div class="flex flex-between">
          <div>
            标签：
            <el-select
              filterable
              clearable
              size="small"
              class="mr10"
              v-model="employeeLabelName"
              @change="labelChange"
              placeholder="请选择标签"
            >
              <el-option
                :label="v"
                :value="v"
                v-for="(v, i) in allLabel"
                :key="i"
              ></el-option>
            </el-select>
          </div>
          <div>
            角色：
            <el-select
              filterable
              clearable
              size="small"
              class="mr10"
              v-model="roleId"
              placeholder="请选择角色"
            >
              <el-option
                :label="v.roleName"
                :value="v.id"
                v-for="(v, i) in allRole"
                :key="i"
              ></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="add" :disabled="labelEmpioyee.length===0||roleId===''"
              >批量配置角色</el-button
            >
          </div>
        </div>

        <div class="mt10">
          <el-table
            :data="labelEmpioyee"
            style="width: 100%"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="username"
              label="用户账号"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="realname"
              label="用户名称"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="workNum"
              label="工号"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="departName"
              label="所属机构"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="isManager"
              label="是否主管"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.isManager === "yes" ? "是" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="workingState"
              label="状态"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.workingState === 'yes'">在职</span>
                <span v-if="scope.row.workingState === 'no'">离职</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="syncFlag"
              label="同步状态"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.syncFlag === "erp" ? "同步" : "非同步"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberMobile"
              label="绑定会员信息"
              header-align="center"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.memberMobile">
                  <div>手机号：{{ scope.row.memberMobile }}</div>
                  <div>会员名：{{ scope.row.memberName }}</div>
                </div>
                <div v-else>未绑定</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      employeeLabelName: "",
      dialogVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      checkedRow: {},
      searchCondition: {},
      allLabel: [],
      labelEmpioyee: [],
      allRole: [],
      roleId: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryAllLabel();
    this.queryAllRole();
  },
  methods: {
    async add() {
      let params = {
        userIdList: this.labelEmpioyee,
        roleId: this.roleId
      };
      const { code } = await this.$store.dispatch("userIdListAddRole", params);
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.queryList();
        this.dialogVisible = false;
        this.labelEmpioyee = [];
        this.employeeLabelName = "";
        this.roleId = "";
      }
    },
    labelChange() {
      this.queryEmpByLabel();
    },
    async queryAllRole() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        noRoleFlag: "yes",
        loginType: "store"
      };
      const { code, result } = await this.$store.dispatch(
        "queryAllRoleList",
        params
      );
      if (code === 0) {
        this.allRole = result.records;
      }
    },
    async queryEmpByLabel() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        noRoleFlag: "yes",
        employeeLabelName: this.employeeLabelName,
        loginType: "store"
      };
      const { code, result } = await this.$store.dispatch(
        "queryEmployeeList",
        params
      );
      if (code === "0") {
        this.labelEmpioyee = result.records;
      }
    },
    async queryAllLabel() {
      const { code, result } = await this.$store.dispatch(
        "queryAllEmployeeLabelName"
      );
      if (code === "0") {
        this.allLabel = result;
      }
    },
    batchSetting() {
      this.dialogVisible = true;
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        noRoleFlag: "yes",
        loginType: "store"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryEmployeeList",
        params
      );

      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.employeeId);
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
